import { useLoaderData } from 'react-router';
import { useAuth } from '../../public/site/AuthProvider';
import { WarrantyReceiptList } from '../WarrantyReceiptList/WarrantyReceiptList';
import type { SubscriptionsLoaderData } from '../../common/loaders';

export const WarrantyReceipts = () => {
  const { authenticatedUser } = useAuth();
  const { subscriptions, aggregations } = useLoaderData() as SubscriptionsLoaderData;

  return (
    <div className="of-message-center-content">
      <WarrantyReceiptList
        warrantyReceipts={subscriptions.searchResults}
        aggregations={aggregations}
        totalItems={subscriptions.total}
        authenticatedUser={authenticatedUser}
      />
    </div>
  );
};
